// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__tSwZc","close":"Modal_close__6dGVX","content":"Modal_content__Mch30"};